export type ShopInitial = "" | "0-9" | "A" | "B" | "C" | "D" | "E" | "F" | "G" | "H" | "I" | "J" | "K" | "L" | "M" | "N" | "O" | "P" | "Q" | "R" | "S" | "T" | "U" | "V" | "W" | "X" | "Y" | "Z";

export const SHOP_INITIALS: ShopInitial[] = ["", "0-9", ..."ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("") as ShopInitial[]];

// Only allow the server's initial-filter contract. Never pass arbitrary search input.
export function normalizeShopInitial(value: unknown): ShopInitial {
  if (typeof value !== "string") return "";
  const initial = value.trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
  return initial === "0-9" || /^[A-Z]$/.test(initial) ? initial as ShopInitial : "";
}

export function shopInitialParam(value: unknown): string | undefined {
  return normalizeShopInitial(value) || undefined;
}

const copy = {
  en: { all: "All", label: "Filter manufacturers by initial", empty: "No manufacturers found for this initial.", error: "Unable to load manufacturers. Please try again.", retry: "Try again" },
  pt: { all: "Todos", label: "Filtrar fabricantes pela inicial", empty: "Nenhum fabricante encontrado para esta inicial.", error: "Não foi possível carregar os fabricantes. Tente novamente.", retry: "Tentar novamente" },
  es: { all: "Todos", label: "Filtrar fabricantes por inicial", empty: "No se encontraron fabricantes para esta inicial.", error: "No se pudieron cargar los fabricantes. Inténtalo de nuevo.", retry: "Intentar de nuevo" },
};

export function shopAlphabetCopy(locale?: string) {
  const language = locale?.toLowerCase().split(/[-_]/)[0];
  return copy[language === "pt" || language === "br" ? "pt" : language === "es" ? "es" : "en"];
}
